import React from 'react';
import { Tooltip, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { useLang } from '../../../../util/lang';

const SubOptCheckBoxLabel = ({ label = '', isShowError = false }) => {
    const getLang = useLang();
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
            }}
        >
            <Typography>{label}</Typography>
            {isShowError && (
                <Tooltip title={getLang('@NewPatient.prescriptionNotes.requiredInformation')}>
                    <ErrorIcon
                        style={{
                            color: 'red',
                        }}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default SubOptCheckBoxLabel;
